.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.alert-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.failed-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.failed-row {
  align-items: center;
  background: var(--color-surface-subtle, var(--color-surface));
  border: 1px solid var(--color-border-subtle, var(--color-border));
  border-radius: 8px;
  display: grid;
  gap: 10px;
  grid-template-columns: 20px 1fr auto;
  padding: 8px 10px;
}

.icon {
  align-items: center;
  color: var(--color-warning, var(--color-muted));
  display: flex;
  justify-content: center;
}

.failed-row[data-permanent='true'] .icon {
  color: var(--color-destructive, var(--color-error));
}

.body {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.footer {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 4px;
}
